export function headerFunc() {
  toggleMenu();
}

export function headerResize() {
  headerHeight();
  bannerHeight();
}

/**
 * ハンバーガーメニュー
 */
function toggleMenu() {
  const $hamburger = $('.js-hamburger');
  const $hamburgerLine = $('.l-header-hamburger__line');
  const $drawer = $('.js-drawer');
  $($hamburger).on('click', function() {
    $($hamburgerLine).toggleClass('is-open');
    $($drawer).toggleClass('is-open');
  });
}

/**
 * ヘッダーの高さ分コンテンツを下げる
 */
function headerHeight() {
  const headerHeight = $('.l-header').height();
  $('body').css('margin-top', headerHeight);
  $('.l-drawer').css('padding-top', headerHeight);
}

/**
 * 追従バナー分余白
 */
function bannerHeight() {
  if (window.matchMedia('(max-width: 979px)').matches) {
    const bannerHeight = $('.l-fixed-banner').height();
    $('.l-footer').css('padding-bottom', bannerHeight);
  }
}